// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT TOUCH :) */

.top-to-btm{
  position: relative;
}

.icon-position{
  position: fixed;
  bottom: 40px;
  right: 25px;
  z-index: 20;
}

.icon-style{
  background-color: #6b6960;
  border: 2px solid #fff;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  color: #fff;
  cursor: pointer;
  animation: movebtn 3s ease-in-out infinite;
  transition: all .5s ease-in-out;
}

.icon-style:hover{
  animation: none;
  background: #fff;
  color: rgb(115 115 115);
  border: 2px solid rgb(115 115 115);
}
    
@keyframes movebtn {
  0%{
    transform: translateY(0px);
  }
  25%{
    transform: translateY(20px);
  }
  50%{
    transform: translateY(0px);
  }
  75%{
    transform: translateY(-20px);
  }
  100%{
    transform: translateY(0px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/scrollbar.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* DO NOT TOUCH :) */\n\n.top-to-btm{\n  position: relative;\n}\n\n.icon-position{\n  position: fixed;\n  bottom: 40px;\n  right: 25px;\n  z-index: 20;\n}\n\n.icon-style{\n  background-color: #6b6960;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  height: 50px;\n  width: 50px;\n  color: #fff;\n  cursor: pointer;\n  animation: movebtn 3s ease-in-out infinite;\n  transition: all .5s ease-in-out;\n}\n\n.icon-style:hover{\n  animation: none;\n  background: #fff;\n  color: rgb(115 115 115);\n  border: 2px solid rgb(115 115 115);\n}\n    \n@keyframes movebtn {\n  0%{\n    transform: translateY(0px);\n  }\n  25%{\n    transform: translateY(20px);\n  }\n  50%{\n    transform: translateY(0px);\n  }\n  75%{\n    transform: translateY(-20px);\n  }\n  100%{\n    transform: translateY(0px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
